
    import { defineComponent, ref, computed } from 'vue';
    import CoralGraph from './components/CoralGraph.vue';
    import { JednaStanice, SigAttrToShow } from './mojetypy';
    import { useMobileDetection } from "vue3-mobile-detection";
  


    type Konfigurace = {
        stanice: JednaStanice[]
    };

    type JmenoHodnota = {
        jmeno: string,
        hodnota: number | object[] | string | string[],
        jednotka: string
    };

    type DejSignalyResult = {
        err: string,
        arrSigs: JmenoHodnota[]
    };


    



    export default defineComponent({
        name: 'App',
        components: {
            CoralGraph
        },

        setup() {
            const msg = ref<string>();

            var nacteneStanice = ref<Array<JednaStanice>>([]);

            var vybranaStanice = ref<JednaStanice>();

            const arrAktualniHodnoty = ref<JmenoHodnota[]>();

            const bMobil = ref(false);
            const bVidetStanice = ref(false);
            const bVidetAktualni = ref(false);
            const bVidetGraf = ref(false);
            const bMobilPozadavekAktualni = ref(false);
            const bMobilPozadavekGraf = ref(false);

            // kdy má být vidět překrývající tlačítko Zpět
            const bVidetBtnZpet = computed<boolean>(() => {
                return bVidetStanice.value == false; // &&          // takže když je něco maximalizováno
                    //(bVidetGraf.value && !bVidetAktualni.value || !bVidetGraf.value && bVidetAktualni.value);
            });

            // aby se tam vešlo tlačítko "Zpět", když je zobrazeno jen Aktuální hodnoty
            // tak budou Aktuální posunuty trochu vpravo
            const computedStyle = computed<string>(() => {
                if (bVidetAktualni.value && bVidetStanice.value == false)
                    return 'margin:1px 60px;';
                else
                    return 'margin:0px;';

            });


            ///////////////////////////////
            // vstupní URL parametry

            // defaultní cesta na konfigurační soubor, úřípadně může být přepsána ... ?config=./tnconfig.json
            var varConfigPathParam = "./tnconfig.json";

            //console.log('AGENT ' + navigator.userAgent);


            let urlParams = new URLSearchParams(window.location.search);        // vezme to, co je za ? tedy  "?mobil=1"

            console.log('****** URL PARS ' + urlParams);

            // na začátku jsou stanice vidět vždy
            bVidetStanice.value = true;

            // zjistit, jestli to je Mobil
            var vvv = useMobileDetection();
            if (vvv.isMobile()) {
                bMobil.value = true;
                bMobilPozadavekAktualni.value = true;
            }

            // mobile=1
            // URL parametr může "přebít" jestli to je mobil
            if (urlParams.has('mobile')) {
                console.log('MOBIL OK ');
                var params = urlParams.get('mobile');      // mobile=1
                if (params != null) {
                    console.log('MOBIL PARAMS ' + params);
                    bMobil.value = true;

                    var iMobil = Number.parseInt(params);
                    if (iMobil & 0x01)
                        bMobilPozadavekAktualni.value = true;
                    if (iMobil & 0x02)
                        bMobilPozadavekGraf.value = true;
                }
            }

            // config=./tnconfig.json
            if (urlParams.has('config')) {
                var paramsConfig = urlParams.get('config');      
                if (paramsConfig != null) {
                    varConfigPathParam = paramsConfig;
                    console.log('config cesta: ' + paramsConfig);
                }
            }

            function fetchKonfiguraci(): void {
                try {
                    //console.log("pred fetchKonfiguraci");

                    fetch(varConfigPathParam)   // './tnconfig.json')
                        .then((response) => {
                            if (response.ok) {
                                return response.json();
                            }
                            throw new Error('ERR fetchKonfiguraci response');
                        })
                        .then(json => {
                            // console.log("fetch2 " + JSON.stringify(json));
                            var k: Konfigurace = json as Konfigurace;
                            // msg.value = " fetchKonfiguraci nacteno OK";
                            nacteneStanice.value = k.stanice;
                            // console.log("fetchKonfiguraci hotovo, nacteneStanice " + nacteneStanice.value);
                        }).catch((error) => {
                            msg.value = "ERR tnconfig.json " + error;
                        });
                }
                catch (err) {
                    if (err) {
                        var txt = "fetchKonfiguraci ERR " + (err as Error).message;
                        console.log(txt);
                        msg.value = txt;
                    }
                }
            }

           
         
             
            // pomocná funkce pro načtení Aktuálních hodnot z Tn
            async function rawFetch(signaly: string[]): Promise<DejSignalyResult> {
                const params = {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ signaly: signaly })
                };

                var sUrlPath = (process.env.NODE_ENV == 'production') ? './Backend/' : './';

                let res = await fetch( sUrlPath + './values', params);
                return await res.json() as DejSignalyResult;
            }

            // načte Aktuální hodnoty z Tn a uloží do reaktivního arrAktualniHodnoty
            function fetchSignaly(signaly: SigAttrToShow[] | string[]): void {
                try {
                    //console.log("**** pred FETCH Signaly");
                    var sigsToFetch: string[] = [];

                    // je jméno tnSignálu zadáno přímo nebo je v { "tnsig": "Sig2", "nickname": ?
                    signaly.forEach((sigObj) => {
                        if (typeof sigObj == 'object') {
                            //var a: SigAttrToShow = sigObj as SigAttrToShow;
                            sigsToFetch.push( (sigObj as SigAttrToShow).tnsig);
                        }
                        else {
                            sigsToFetch.push(sigObj);       // je to string
                        }
                    });


                    rawFetch(sigsToFetch).then(vys => {
                        //console.log("**** za FETCH Signaly");
                        if (vys == null) {
                            msg.value = "ERR fetchSignaly NULL";
                        }
                        else if (vys.err != null) {
                            msg.value = "ERR fetchSignaly " + vys.err;
                        }
                        else {
                            ///////////////////////////////////////////////
                            // signály a jejich hodnoty nahrány OK

                            // transformace jmen a hodnot, pokud to zadání vyžadovalo
                            vys.arrSigs.forEach((sigVys, idx) => {

                                // není zadán jen prostý string jména, ale  { "tnsig": "Sig2", "nickname": "mojenickname", "format": "hex" },
                                if (typeof signaly[idx] == 'object') {
                                    var s: SigAttrToShow = signaly[idx] as SigAttrToShow;

                                    // pokud bylo zadáno nickname, tak ho přepiš
                                    if (s.nickname != null)
                                        sigVys.jmeno = s.nickname;

                                    // pokud bylo zadáno "format": "hex", vytiskni hodnotu jako HEX, platí i pro pole
                                    if (s.format == 'hex') {

                                        // je to pole hodnot ( např. čísla Vodoměrů)
                                        if (Array.isArray(sigVys.hodnota)) {
                                            var vys: string[] = [];

                                            sigVys.hodnota.forEach(itm => {
                                                vys.push(Number(itm).toString(16).toUpperCase());
                                            });

                                            sigVys.hodnota = vys;
                                        }
                                        // jednoduchá hodnota
                                        else {
                                            sigVys.hodnota = Number(sigVys.hodnota).toString(16).toUpperCase();
                                        }
                                    }

                                    // počet desetinných míst je zadán
                                    if (!isNaN(s.decimalPlaces)) {
                                        if (typeof (sigVys.hodnota) == 'number') {
                                            sigVys.hodnota = sigVys.hodnota.toFixed(s.decimalPlaces);
                                        }
                                    }

                                    // jednotka
                                    sigVys.jednotka = s.jednotka;

                                }
                            });

                            // celkový výsledek jmen a hodnot
                            arrAktualniHodnoty.value = vys.arrSigs; 
                        }
                        // signály a jejich hodnoty nahrány OK
                        //////////////////////////////////////////////////////
                    });
                }
                catch (err) {
                    if (err) {
                        var txt = "fetchSignaly ERR " + (err as Error).message;
                        console.log(txt);
                        msg.value = txt;
                    }
                }
            }

            // vybrala se nějaká stanice
            function vyberStanice(stanice: JednaStanice) {
                //console.log("vybrana stanice " + stanice.jmeno);

                // natáhnout data pro vybranou stanici
                if (stanice != null) {
                    fetchSignaly(stanice.sig);

                    // reaktivně se pošle do Graf
                    vybranaStanice.value = stanice;
                }

                // Mobil a ťuklo se na výběr stanice
                if (bMobil.value) {
                    bVidetStanice.value = false;
                    bVidetAktualni.value = bMobilPozadavekAktualni.value;
                    bVidetGraf.value = bMobilPozadavekGraf.value;
                }
                else {
                    // pro ne-mobil
                    bVidetStanice.value = true;
                    bVidetAktualni.value = true;
                    bVidetGraf.value = true;
                }
            }

            function btnZpet() {
                if (bMobil.value) {
                    bVidetStanice.value = true;
                    bVidetAktualni.value = false;
                    bVidetGraf.value = false;
                }
                else {
                    // pro ne-mobil
                    bVidetStanice.value = true;
                    bVidetAktualni.value = true;
                    bVidetGraf.value = true;
                }
            }

            function btnPouzeGraf() {
                bVidetStanice.value = false;
                bVidetAktualni.value = false;
            }


            fetchKonfiguraci();

          

            return {
                msg,
                nacteneStanice,
                vyberStanice,
                vybranaStanice,
                arrAktualniHodnoty,
                btnPouzeGraf,
                btnZpet,
                bVidetStanice,
                bVidetAktualni,
                bVidetGraf,
                bVidetBtnZpet,
                bMobil,
                bMobilPozadavekAktualni,
                bMobilPozadavekGraf,
                computedStyle
            };
        }
    });

  

